import { useGetPastStudentsByMentor } from '@actions';
import PastStudentsTable from '@modules/Mentor/PastStudents/PastStudentsTable';

const PastStudents = () => {
  const { data: pastStudents, isLoading } = useGetPastStudentsByMentor();

  return (
    <section className="laptop:ml-1 min-h-screen w-full pt-6 bg-surfaceBackground">
      <section className="max-w-[1564px] flex flex-col m-auto gap-6 p-4 tablet:p-6 laptop:px-24">
        <div className="flex flex-col gap-1">
          <h1 className="font-raleway font-semibold text-2xl">Past Students</h1>
          <p className="font-raleway text-sm text-customGrey">
            Every student you mentored in the past, across all their enrollments. Students you are
            currently mentoring live under My Students.
          </p>
        </div>

        <PastStudentsTable students={pastStudents} isLoading={isLoading} />
      </section>
    </section>
  );
};

export default PastStudents;
